import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { FaCookieBite } from "react-icons/fa"

const COOKIE_GA  = "gatsby-gdpr-google-analytics"
const COOKIE_FB  = "gatsby-gdpr-facebook-pixel"
const MAX_AGE    = 60 * 60 * 24 * 365 // 1 year

function getCookie(name) {
  if (typeof document === "undefined") return null
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"))
  return match ? match[2] : null
}

function setConsent(value) {
  const opts = `path=/; max-age=${MAX_AGE}; SameSite=Lax`
  document.cookie = `${COOKIE_GA}=${value}; ${opts}`
  document.cookie = `${COOKIE_FB}=${value}; ${opts}`
}

// Dynamically initialise Facebook Pixel without requiring a page reload.
// This is Meta's standard base code — runs only after the user accepts.
function initFacebookPixel() {
  const pixelId = process.env.GATSBY_FACEBOOK_PIXEL_ID
  if (!pixelId || window.fbq) return

  const n = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = "2.0"
  n.queue = []

  const script = document.createElement("script")
  script.async = true
  script.src = "https://connect.facebook.net/en_US/fbevents.js"
  document.head.appendChild(script)

  window.fbq("init", pixelId)
  window.fbq("track", "PageView")
}

export const CookieBanner = () => {
  const [visible, setVisible] = React.useState(false)

  React.useEffect(() => {
    // Show only if the user hasn't made a choice yet
    if (!getCookie(COOKIE_GA)) setVisible(true)
  }, [])

  if (!visible) return null

  const handleAccept = () => {
    setConsent("true")
    initFacebookPixel()
    setVisible(false)
  }

  const handleDecline = () => {
    setConsent("false")
    setVisible(false)
  }

  return (
    <div style={styles.banner}>
      <Container>
        <Row className="align-items-center gy-3">
          {/* Icon + text */}
          <Col xs={12} md={8} className="d-flex align-items-start gap-3">
            <FaCookieBite style={styles.icon} />
            <div>
              <p style={styles.title}>We use cookies</p>
              <p style={styles.body}>
                We use cookies to personalise content, run analytics, and improve
                our advertising. By clicking <strong>Accept All</strong> you
                consent to our use of cookies.{" "}
                <a href="/privacy-policy" style={styles.link}>
                  Learn more
                </a>
              </p>
            </div>
          </Col>

          {/* Buttons */}
          <Col
            xs={12}
            md={4}
            className="d-flex flex-row flex-md-column flex-lg-row gap-2 justify-content-start justify-content-md-end"
          >
            <button onClick={handleAccept} className="btn-st" style={styles.acceptBtn}>
              Accept All
            </button>
            <button onClick={handleDecline} style={styles.declineBtn}>
              Decline
            </button>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    backgroundColor: "#2b2b2b",
    borderTop: "3px solid hsl(205, 100%, 52%)",
    padding: "1.25rem 0",
    boxShadow: "0 -4px 24px rgba(0,0,0,0.35)",
  },
  icon: {
    color: "hsl(205, 100%, 52%)",
    fontSize: "2rem",
    flexShrink: 0,
    marginTop: "0.15rem",
  },
  title: {
    color: "#ffffff",
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: "0.95rem",
    marginBottom: "0.25rem",
  },
  body: {
    color: "#b9b9b9",
    fontFamily: "Montserrat",
    fontSize: "0.82rem",
    marginBottom: 0,
    lineHeight: 1.6,
  },
  link: {
    color: "hsl(205, 100%, 65%)",
    textDecoration: "underline",
  },
  acceptBtn: {
    margin: 0,
    padding: "0.55rem 1.25rem",
    fontSize: "0.875rem",
    whiteSpace: "nowrap",
  },
  declineBtn: {
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.3)",
    color: "#b9b9b9",
    padding: "0.55rem 1.25rem",
    borderRadius: "0.5rem",
    fontFamily: "Montserrat",
    fontSize: "0.875rem",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
}
